import React, { useRef } from 'react';
import '../../Css/Career.css';
import {
  career1,
  about,
  salaryhike,
  selfDevlopment,
  working,
  people,
  team,
  pay,
  earth,
  arrow,
  pngegg1,
  pngegg2,
  pngegg3,
  pngegg4,
  pngegg5,
  pngegg6,
  pngegg7,
  pngegg9,
  pngegg10
} from "../images"

const Career = () => {
  const currentOpeningsRef = useRef(null);

  const scrollToCurrentOpenings = () => {
    if (currentOpeningsRef.current) {
      currentOpeningsRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  };
  return (
    <>
      {/* About banner */}
      <div id="box-search">
        <div className="thumbnail">

          <div >
            <div>

              <h2 className="about-us-career">
                <p className='career-text'>
                  Join a company that values innovation and encourages
                  you to think creatively, bringing your unique ideas to life<div className="centered-button-container">
                    <button onClick={scrollToCurrentOpenings} className="career-btn">
                      𝖢𝗎𝗋𝗋𝖾𝗇𝗍 𝖮𝗉𝖾𝗇𝗂𝗇𝗀𝗌
                    </button>

                  </div>
                </p>


              </h2>



            </div>
          </div>
        </div>
      </div>
      {/* About banner closed */}
      <div className="container margin-container">
        <div style={{ marginTop: "4rem" }} className="container highlight">
          <hr />
        </div>
        <div className="about">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-sm-6 about-col">
                <img
                  className="client-img"
                  alt="about"
                  src={career1}
                  loading="lazy"
                />
              </div>
              <div className="col-sm-6  about-second">
              <h2  className="alltext  careerstartheading">
                  Career with UpSys<span></span>
                </h2>
                <p style={{ fontSize: '18px' }}>
                  At UPSYS, we believe in fostering a dynamic and inclusive workplace where talent
                  thrives. Join our team and embark on a journey where innovation meets purpose.
                  We offer more than just a job; we offer a fulfilling career path. As a part of our family,
                  you'll have the opportunity to collaborate with passionate professionals, grow your
                  skills, and make a meaningful impact on the world. Explore our current job openings
                  and take the first step towards a rewarding career at UPSYS.
                </p>
                <b> <a href="https://www.linkedin.com/company/upsys-it-and-marketing-solutions/jobs/">
                  Explore Internships{' '}

                  <img src={arrow} className="explore" />
                </a>
                </b>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div style={{ marginTop: "3rem" }} className="container highlight">
        <hr />
      </div>
      <div className="about">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-sm-6  about-second">
              <h2 className="alltext careerstartheading">
                Why join us<b className="question-mark">?</b>
              </h2>
              <p style={{ fontSize: '18px', color: '#36373b' }}>
                At UPSYS, we're more than just a workplace; we're a community of
                dedicated individuals who share a common passion for excellence. When you join
                our team, you become part of an environment that encourages innovation, values
                diversity, and promotes personal and professional growth. We're committed to
                nurturing talent, fostering creativity, and providing opportunities for you to thrive.
                Here, you'll work on exciting projects, collaborate with talented colleagues, and
                make a real impact. We believe in work-life balance, offer competitive compensation
                and benefits, and celebrate achievements together. Join us and embark on a
                rewarding journey where your skills and aspirations are valued, and your career
                potential knows no bounds.
              </p>
            </div>
            <div className="col-sm-6 about-col">
              <img
                className="client-img"
                alt="about"
                src="https://img.freepik.com/free-vector/goal-achievement-teamwork-business-concept-career-growth-cooperation-development-project_107791-29.jpg?size=626&ext=jpg&uid=R84979278&ga=GA1.1.25719282.1696605811&semt=sph"

                loading="lazy"
              />
            </div>
          </div>
        </div>
      </div>
      <div className="industries">
        <div className="container">
          <div className="career">
            <div className="career1">
              <img
                src={about}
                className="q-img"
                alt="img"
                loading="lazy"
              />
              <p className="q-text">Right Opportunity & Responsibility to Right Candidate</p>
            </div>
            <div className="career2">
              <img
                src={salaryhike}
                className="q-img"
                alt="img"
                loading="lazy"
              />
              <p className="q-text">Good Salary</p>
            </div>
            <div className="career1">
              <img
                src={selfDevlopment}
                className="q-img"
                alt="img"
                loading="lazy"
              />
              <p className="q-text">Platform for Self-Development</p>
            </div>
            <div className="career2">
              <img
                src={working}
                className="q-img"
                alt="img"
                loading="lazy"
              />
              <p className="q-text">Professional work Culture</p>
            </div>
          </div>
          <div className="career">
            <div className="career1">
              <img
                src={people}
                className="q-img"
                alt="img"
                loading="lazy"
              />
              <p className="q-text">No work under Pressure</p>
            </div>
            <div className="career2">
              <img
                src={team}
                className="q-img"
                alt="img"
                loading="lazy"
              />
              <p className="q-text">Team building & Personality Development Program</p>
            </div>
            <div className="career1">
              <img
                src={pay}
                className="q-img"
                alt="img"
                loading="lazy"
              />
              <p className="q-text">Good Compensation</p>
            </div>
            <div className="career2">
              <img
                src={earth}
                className="q-img"
                alt="img"
                loading="lazy"
              />
              <p className="q-text">CSR Activities</p>
            </div>
          </div>
        </div>
      </div>
      <p ref={currentOpeningsRef}></p>
      <div style={{ marginTop: "3rem" }} className="container highlight">
        <hr />
      </div>
      <h1 className="careerstartheading1 alltext">
        Current Openings<span></span>
      </h1>
      <div className="container">
        <div className="job-heading">
          <span style={{ fontSize: '24px', marginLeft: '10px', border: '1px solid rgba(0,0,0,.13)', padding: '4px' }}>
            Job Types
          </span>
          <span
            className="location"
            style={{ fontSize: '24px', marginLeft: '20px', padding: '4px', border: '1px solid rgba(0,0,0,.13)' }}
          >
            Location
          </span>
        </div>
        <div className="Jobs mt-4">
          <div className="job">
            <span>Not Open Now !</span>
            {/* <p>
              Indore{' '} */}
            {/* <a  href="#" className="apply">
                Apply <img className="arrow8" src={arrow} alt="img" loading="lazy" />
              </a> */}
            {/* </p> */}
          </div>
        </div>
      </div>


      <div className="part">
        <div className="container part-container">
          <div className="row">
            <div className="col-md-6 col-6">
              {/* <div className="main-items">
                <h1 className="items">Services</h1>
                <p className="item">
                  <a className="items-a" href="./Web.html">
                    Web Development
                  </a>
                </p>
                <p className="item">
                  <a className="items-a" href="./Mobile.html">
                    Mobile Development
                  </a>
                </p>
                <p className="item">
                  <a className="items-a" href="./Iot.html">
                    IOT Solution
                  </a>
                </p>
                <p className="item">
                  <a className="items-a" href="./Datascience.html">
                    Data Science
                  </a>
                </p>
                <p className="item">
                  <a className="items-a" href="./Quality.html">
                    Quality Analysis
                  </a>
                </p>
                <p className="item">
                  <a className="items-a" href="./Geeks.html">
                    Geeks on Demand
                  </a>
                </p>
              </div> */}
            </div>

            {/* <div className="col-md-6 col-6">
              <div className="main-items">
                <h1 className="items">About UpSys</h1>
                <p className="item">
                  <a className="items-a" href="About.html#history">
                    History
                  </a>
                </p>
                <p className="item">
                  <a className="items-a" href="Careers.html">
                    Careers
                  </a>
                </p>
                <p className="item">
                  <a
                    className="items-a"
                    href="https://maps.google.com/?cid=2541387411344752507&entry=gps"
                  >
                    Address
                  </a>
                </p>
              </div>
            </div> */}
          </div>
        </div>
      </div>

      <div style={{ marginTop: "3rem" }} className="container highlight">
        <hr />
      </div>
      <div className="part">
        <div className="container part-container">
          <div className="row">
            <div className="col-md-3 col-6">
              <div className="client-section1">
                <img
                  src={pngegg1}
                  alt="logo"
                  loading="lazy"
                  className="client1-img"
                />
              </div>
            </div>
            <div className="col-md-3 col-6">
              <div className="client-section1">
                <img
                  src={pngegg2}
                  alt="logo"
                  loading="lazy"
                  className="client1-img"
                />
              </div>
            </div>
            <div className="col-md-3 col-6">
              <div className="client-section1">
                <img
                  src={pngegg3}
                  alt="logo"
                  loading="lazy"
                  className="client1-img"
                />
              </div>
            </div>
            <div className="col-md-3 col-6">
              <div className="client-section1">
                <img
                  src={
                    pngegg10
                  }
                  alt="logo"
                  loading="lazy"
                  className="client1-img"
                />
              </div>
            </div>
            <div className="col-md-3 col-6">
              <div className="client-section1">
                <img
                  src={pngegg5}
                  alt="logo"
                  loading="lazy"
                  className="client1-img"
                />
              </div>
            </div>
            <div className="col-md-3 col-6">
              <div className="client1-section1">
                <img
                  src={pngegg6}
                  alt="logo"
                  loading="lazy"
                  className="client1-img"
                />
              </div>
            </div>
            <div className="col-md-3 col-6">
              <div className="client-section1">
                <img
                  src={pngegg7}
                  alt="logo"
                  loading="lazy"
                  className="client1-img"
                />
              </div>
            </div>
            <div className="col-md-3 col-6">
              <div className="client-section">
                <img
                  src={pngegg9}
                  alt="logo"
                  loading="lazy"
                  className="client1-img"
                />
              </div>
            </div>

          </div>
        </div>
      </div>
      <div style={{ marginTop: "4rem" }} className="container highlight">
        <hr />
      </div>
    </>
  );
};

export default Career;
